import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
// store
import AppStore from "@/app-store";
import Store from "@/core/reducers/SimpleServiceStore";
// actions
import ClientContentMetricsAction from "@/core/actions/services/metrics/ClientContentMetricsAction";
// types
import EContentMetricsType from "@/core/enums/EContentMetricsType";

export type TContentMetric = {
    contentId?:string;
    metricType:EContentMetricsType;
    count: number;
}

type TUseContentMetricsOut = {
    payload: TContentMetric[]|null;
    _listContentMetric: (contentId:string) => void;
    _listContentMetrics: (contentIds:string[]) => void;
}

type TUseContentMetrics = {
    unqKey:string;
    contentId?:string;
    contentIds?:string[];
}

const useContentMetrics = ( props:TUseContentMetrics ):TUseContentMetricsOut => {
    const dispatch = useDispatch();

    const { unqKey, contentId, contentIds } = props;

    const clientContentMetricsAction = new ClientContentMetricsAction(dispatch, unqKey);
    AppStore.reducerManager.add(unqKey, Store(unqKey, clientContentMetricsAction.serviceCode));
    const payload = useSelector((state:any) => state?.[unqKey]?.list?.payload, shallowEqual);

    useEffect(() => { return () => { AppStore.reducerManager.remove(unqKey); } }, [])
    useEffect(() => { if ( contentId ) _listContentMetric(contentId); else if ( contentIds ) _listContentMetrics(contentIds) }, [contentId, contentIds]);

    const _listContentMetric = ( contentId:string ) => {
        clientContentMetricsAction.list({
            servicePayload: { queryOptions: { apply:`filter(contentStatus eq 1 and contentId eq ${contentId})/groupby((metricType),aggregate($count as count))` } }
        })
    }

    const _listContentMetrics = ( contentIds:string[] ) => {
        clientContentMetricsAction.list({
            servicePayload: { queryOptions: { apply:`filter(contentStatus eq 1 and contentId in (${contentIds.join(",")}))/groupby((contentId,metricType),aggregate($count as count))`} }
        })
    }

    return {
        payload,
        _listContentMetric,
        _listContentMetrics,
    }
}

export default useContentMetrics;
